import { Skeleton } from "antd"
import type { MenuItemType } from "antd/es/menu/interface"
import React from "react"

import type { AlbumListItem } from "../../../../../../Album/types/album.types.ts"
import { ALBUM_CARD_WITH } from "../album-card-width.ts"
import { AlbumCard } from "../AlbumCard/AlbumCard.tsx"
import { CreateAlbumCard } from "./CreateAlbumCard.tsx"

const gridStyle = {
  gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
}

export const AlbumsGridLoader = ({
  count = 4,
  className = ""
}: {
  count?: number
  className?: string
}) => (
  <div style={gridStyle} className={`grid gap-4 ${className}`.trimEnd()}>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton.Node
        key={i}
        active
        style={{ width: "100%", height: "220px" }}
        className="w-full"
      />
    ))}
  </div>
)

interface AlbumsGridViewProps {
  albums: AlbumListItem[]
  createAllowed: boolean
  onCreateAlbumClick?: () => void
  onView?: (id: string) => void
  menuItemsFor: (album: AlbumListItem) => MenuItemType[]
}

export const AlbumsGridView = ({
  albums,
  createAllowed,
  onCreateAlbumClick,
  onView,
  menuItemsFor
}: AlbumsGridViewProps) => {
  return (
    <div style={gridStyle} className="grid gap-4">
      {createAllowed && (
        <div style={{ minHeight: 220 }}>
          <CreateAlbumCard onClick={onCreateAlbumClick} />
        </div>
      )}

      {albums.map((album) => (
        <AlbumCard
          key={album.id}
          album={album}
          onView={onView}
          actions={menuItemsFor(album)}
        />
      ))}
    </div>
  )
}
